import { Route, Link, Routes, Outlet } from 'react-router-dom'
import { Error500 } from './components/Error500'
import Error404 from './components/Error404'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
// import { toAbsoluteUrl } from '../../../_metronic/helpers'

const ErrorsLayout = () => {
    const { t } = useTranslation()
	return (
		<div className='d-flex flex-column flex-root justify-content-center align-items-center' style={{ marginTop: '20vh' }}>
			<div
				className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
			// style={{ backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/progress-hd.png')}')` }}
			>
				<div className='d-flex flex-column flex-column-fluid text-center p-10 py-lg-20'>

					<div className='pt-lg-10 mb-10'>
						<Outlet />
						<div className='text-center'>
							<Link to='/' className='btn btn-lg btn-primary fw-bolder'>
								{t('go_to_homepage')}
							</Link>
						</div>
					</div>

				</div>

			</div>
		</div>
	)
}

const ErrorsPage: FC = () => (
	<Routes>
		<Route element={<ErrorsLayout />}>
			<Route path='404' element={<Error404 />} />
			<Route path='500' element={<Error500 />} />
			<Route index element={<Error404 />} />
		</Route>
	</Routes>
)

export default ErrorsPage;
